<template>
  <div class="test-questions">
    <!-- 导航栏区域 -->
    <van-nav-bar class="nav_bar" placeholder fixed @click-left="$router.go(-1)">
      <template slot="left">
        <van-icon class="left_arrow" name="arrow-left" />
      </template>
      <template slot="title">
        <div>
          <span>倒计时：</span>
          <span class="time">{{ lefttime | formatDate }}</span>
        </div>
      </template>
    </van-nav-bar>
    <!-- 导航栏区域 -->

    <!-- 答题区域 -->
    <div class="content-box">
      <question-item v-show="questionIndex === index" v-for="(item, index) in questionList" :key="item.id" :index="index" :questionInfo="item" @on-change="onChange"></question-item>
    </div>
    <!-- 答题区域 -->

    <!-- 按钮区域 -->
    <div class="bottom-button">
      <van-button class="btn" @click="switchTopic('on')">上一题</van-button>
      <van-button v-show="questionIndex < questionLength - 1" class="btn" @click="switchTopic('under')">下一题</van-button>
      <van-button v-show="questionIndex === questionLength - 1" class="btn" @click="submit">提交</van-button>
    </div>
    <!-- 按钮区域 -->
  </div>
</template>
<script>
import { getTestQuestions, postMyTest } from '@/api/Mine/TestQuestions'
import questionItem from './components/question-item.vue'
export default {
  name: 'TestQuestions',
  components: { questionItem },
  props: {
    // 考试计划ID
    Id: {
      type: String,
      require: true
    }
  },
  data() {
    return {
      // 控制题目显示的索引
      questionIndex: 0,
      // 考试倒计时
      lefttime: 0,
      // 考试总时长
      time: null,
      // 考试题目
      questionList: [],
      // 题目数量
      questionLength: 0,
      // 考试题目答案
      questionForm: {
        1: [],
        2: [],
        3: []
      },
      // 考试题目ID
      user_exams_id: null
    }
  },
  mounted() {
    // 获取考试题目
    this.getTestQuestions()
    // 显示欢迎提示框
    this.showWelcomeDialog()
  },
  methods: {
    showWelcomeDialog() {
      this.$dialog.alert({
        title: '考试须知',
        className: 'welcome-modal',
        message: `
          <div class="modal-header" >
            <h2>考试温馨提示</h2>
            <p>请仔细阅读以下考试规则</p>
          </div>
          <div class="modal-body" style="">
            <div class="exam-info">
              <div class="info-item">
                <div class="info-label">考试类型：</div>
                <div class="info-value">开卷考试</div>
              </div>
              <div class="info-item">
                <div class="info-label">考试时长：</div>
                <div class="info-value">120分钟</div>
              </div>
              <div class="info-item">
                <div class="info-label">题目数量：</div>
                <div class="info-value">50题</div>
              </div>
              <div class="info-item">
                <div class="info-label">题目类型：</div>
                <div class="info-value">判断题与选择题</div>
              </div>
            </div>
            <div class="rules-list">
              <div class="rule-item" >
                <div class="rule-icon">1</div>
                <div>请在限定时间内完成答题，交卷后系统将自动判卷并即时反馈成绩。</div>
              </div>
              <div class="rule-item" >
                <div class="rule-icon">2</div>
                <div>考试成绩如果未达到及格线（60分），需要进行补考。</div>
              </div>
              <div class="rule-item">
                <div class="rule-icon">3</div>
                <div>考试过程中请不要关闭浏览器，否则答题进度将丢失。</div>
              </div>
              <div class="rule-item">
                <div class="rule-icon">4</div>
                <div>可以通过顶部进度条查看答题进度，左侧导航按钮切换题目。</div>
              </div>
            </div>

            <div class="tip-text">预祝您考试顺利通过！</div>
          </div>
          <style>
          * {
                margin: 0;
                padding: 0;
                box-sizing: border-box;
              }
              .van-dialog__message{
                white-space: normal !important;
              }
              body {
                font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
                background-color: #f5f7fa;
                color: #333;
              }

              .welcome-modal {
                border-radius: 16px;
                overflow: hidden;
              }
              .modal-header {
                background: linear-gradient(135deg, #3498db, #2c3e50);
                padding: 5px;
                text-align: center;
                color: white;
              }
              .modal-header h2 {
                font-size: 14px;
                margin-bottom: 10px;
              }
              .modal-body {
                padding: 5px;
                max-height: 60vh;
                overflow-y: auto;
              }
              .rules-list {
                padding: 0 10px;
                text-align: left;

                font-weight: bold;
                text-align: left;
                margin-top: 15px;
                padding: 5px;
                background: #fff8e6;
                border-radius: 8px;

              }
              .rule-item {
                display: flex;
                margin-bottom: 18px;
                line-height: 1.6;
              }
              .rule-icon {
                min-width: 24px;
                height: 24px;
                background: #3498db;
                border-radius: 50%;
                color: white;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 12px;
                font-size: 14px;
                margin-top: 3px;
              }
              .modal-footer {
                padding: 1px 2px 2px;
                text-align: center;
              }
              .confirm-btn {
                background: linear-gradient(135deg, #2ecc71, #27ae60);
                color: white;
                border: none;
                width: 80%;
                height: 50px;
                border-radius: 25px;
                font-size: 18px;
                font-weight: bold;
                box-shadow: 0 4px 10px rgba(46, 204, 113, 0.3);
              }
              .exam-info {
                background: #e8f4ff;
                border-radius: 10px;
                padding: 1px;
                margin: 1px 0;
                border-left: 4px solid #3498db;
              }
              .info-item {
                display: flex;
                margin-bottom: 10px;
              }
              .info-label {
                font-weight: bold;
                min-width: 80px;
                color: #2c3e50;
              }
              .info-value {
                color: #3498db;
                font-weight: 500;
              }
              .tip-text {
                color: #e74c3c;
                font-weight: bold;
                text-align: center;
                margin-top: 15px;
                padding: 0px;
                background: #fff8e6;
                border-radius: 8px;
                border: 1px dashed #f39c12;
              }
          </style>
        `,
        confirmButtonText: '开始考试',
        confirmButtonColor: '#2ecc71'
      }).then(() => {
        console.log('开始考试')
      })
    },
    // 获取考试题目
    async getTestQuestions() {
      const res = await getTestQuestions(this.Id)
      if (res.code === 0) {
        this.$router.push('/MyTest')
        return this.$toast.fail(res.msg)
      }
      this.lefttime = res.data.msg.hours * 60
      this.time = res.data.msg.hours * 60
      // 倒计时
      this.timeOut()
      this.questionList = res.data.questions
      this.questionLength = this.questionList.length
      this.user_exams_id = res.data.msg.user_exams_id
    },
    // 倒计时
    timeOut() {
      const timeInterval = setInterval(() => {
        this.lefttime = this.lefttime - 1
        if (this.lefttime <= 0) {
          this.submit()
          this.$toast('时间到')
          clearInterval(timeInterval)
        }
      }, 1000)
    },
    // 切换题目
    switchTopic(value) {
      if (value === 'on') {
        if (this.questionIndex === 0) {
          this.$toast('当前题目为第一题')
        } else {
          this.questionIndex -= 1
        }
      }
      if (value === 'under') {
        this.questionIndex += 1
      }
    },
    // 修改答案
    onChange(value) {
      const obj = {
        id: value.id,
        answer: value.answer
      }
      // 单选
      if (value.type === '1') {
        // 判断是否存在当前题目
        const index = this.questionForm[1].findIndex(item => item.id === obj.id)
        if (index === -1) {
          this.questionForm[1].push(obj)
        } else {
          this.questionForm[1][index].answer = obj.answer
        }
      }
      // 多选
      if (value.type === '2') {
        // 判断是否存在当前题目
        const index = this.questionForm[2].findIndex(item => item.id === obj.id)
        if (index === -1) {
          this.questionForm[2].push(obj)
        } else {
          this.questionForm[2][index].answer = obj.answer
        }
      }
      // 判断
      if (value.type === '3') {
        // 判断是否存在当前题目
        const index = this.questionForm[3].findIndex(item => item.id === obj.id)
        if (index === -1) {
          this.questionForm[3].push(obj)
        } else {
          this.questionForm[3][index].answer = obj.answer
        }
      }
    },
    // 提交
    async submit() {
      const obj = {
        user_exams_id: this.user_exams_id,
        question: this.questionForm,
        usetime: this.time - this.lefttime
      }
      const { data: res } = await postMyTest(obj)
      let message = null
      if (res.status === '0') {
        message = '考试未完成'
      }
      if (res.status === '1') {
        message = '您此次考试的成绩是' + res.score + '分，恭喜您考试通过！'
      }
      if (res.status === '2') {
        message = '您此次考试的成绩没有达到及格线，需要补考，请您在合适的时间重新考试。'
      }
      if (res.status === '3') {
        message = '您此次考试的成绩没有达到及格线，需要补考，请您在合适的时间重新考试。'
      }
      if (res.status === '4') {
        message = '已发证书'
      }
      this.$dialog
        .alert({
          message: message
        })
        .then(() => {
          this.$router.push('/MyTest')
        })
    }
  }
}
</script>
<style lang="less" scoped>
.nav_bar .time {
  font-size: 32px;
  color: #999999;
}
.content-box {
  padding-top: 30px;
}
.bottom-button {
  width: 100%;
  position: fixed;
  bottom: 98px;
  display: flex;
  justify-content: space-around;
  .btn {
    width: 194px;
    height: 66px;
    padding: 0;
    line-height: 66px;
    background: #fed30b;
    border-radius: 30px;
    font-size: 28px;
    font-weight: bold;
    color: #ffffff;
  }
}
.modal-header {
  background: linear-gradient(135deg, #3498db, #2c3e50);
  padding: 25px 20px;
  text-align: center;
  color: white;
}
.modal-header h2 {
  font-size: 24px;
  margin-bottom: 10px;
}
.modal-body {
  padding: 25px 20px;
  max-height: 60vh;
  overflow-y: auto;
}
.rules-list {
  padding: 0 20px;
}
.rule-item {
  display: flex;
  margin-bottom: 18px;
  line-height: 1.6;
}
.van-dialog__message{
  white-space: normal !important;
}
.el-dialog__body{
    padding:0 !important;
    padding-left: 2rem !important;
    padding-right: 2rem !important;
    padding-bottom: 0.55rem !important;
    white-space: pre !important;
}
</style>
